module.exports = __webpack_public_path__ + "img/Jump Screenshoot (0-00-09-06)_12.3c6180fb.jpg";